import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  checkStock, getOperationalIdentifier, CardRow, StatusBadge, titleSx, captionSx,
  getOverheadDisplay, getOverheadLabel, OverheadValue, getDetectedDisplay, DetectedValue,
} from '../taskUtils';

export default function NoLocation({ task, t, brandDict, completed }) {
  const { description, product_description, stock_status, status } = task;
  const brandName = brandDict?.[task.brand_id];
  const identifier = getOperationalIdentifier(task, t);
  const overheadDisplay = getOverheadDisplay(task, t);
  const detectedDisplay = getDetectedDisplay(task, t);

  return (
    <Box sx={{ minWidth: 0, width: "100%" }}>
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, flexWrap: 'nowrap' }}>
        <Typography variant="subtitle2" fontWeight={700} sx={{ ...titleSx, flexShrink: 1, minWidth: 0 }}>
          {description || product_description || '—'}
        </Typography>
        {completed && <StatusBadge status={status} label={t(`bruno.task_status.${status}`, status)} />}
      </Box>
      {brandName && (
        <Typography variant="caption" color="text.disabled" display="block" sx={captionSx}>
          {brandName}
        </Typography>
      )}
      <CardRow label={identifier.label} value={identifier.value} />
      {overheadDisplay && (
        <CardRow label={getOverheadLabel(t)} value={<OverheadValue display={overheadDisplay} dense />} />
      )}
      {detectedDisplay && (
        <CardRow label={detectedDisplay.label} value={<DetectedValue display={detectedDisplay} dense />} />
      )}
      <CardRow label={t('bruno.tasks_details.stock', 'Stock')} value={checkStock(stock_status)} />
    </Box>
  );
}
